function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.97212 0H0.462185C0.20693 0 0 0.206958 0 0.462213V6.97123C0 7.2274 0.20693 7.43433 0.462185 7.43433H7.43433V0.462213C7.43433 0.206958 7.22738 0 6.97212 0Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5375 0H9.02762C8.77236 0 8.56543 0.206958 8.56543 0.462213V7.43433H15.5375C15.7928 7.43433 15.9998 7.2274 15.9998 6.97123V0.462213C15.9998 0.206958 15.7928 0 15.5375 0Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 9.02789V15.5378C0 15.7931 0.20693 16 0.462185 16H6.97212C7.22738 16 7.43433 15.7931 7.43433 15.5378V8.56567H0.462185C0.20693 8.56567 0 8.77263 0 9.02789Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5375 8.56567H8.56543V15.5378C8.56543 15.7931 8.77236 16 9.02762 16H15.5375C15.7928 16 15.9998 15.7931 15.9998 15.5378V9.02789C15.9998 8.77263 15.7928 8.56567 15.5375 8.56567Z",
  fill: "currentColor"
});

var SvgCaseList = function SvgCaseList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaseList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caseList.a4eed059.svg";
export { ForwardRef as ReactComponent };